export default __webpack_public_path__ + "static/media/Rodolfo1.25cb2f2b.png";